import { render, staticRenderFns } from "./PluginLoader.vue?vue&type=template&id=41db6721&scoped=true"
import script from "./PluginLoader.vue?vue&type=script&lang=js"
export * from "./PluginLoader.vue?vue&type=script&lang=js"
import style0 from "./PluginLoader.vue?vue&type=style&index=0&id=41db6721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db6721",
  null
  
)

export default component.exports